var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wallet_24dp-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "0418\\u66F4\\u65B0--my-balance\\u5F39\\u7A97--send\\u65B0\\u589E",
    transform: "translate(-1048.000000, -386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(958.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-40",
    transform: "translate(16.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-41",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet_24dp-4",
    transform: "translate(12.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1578947,16.5 L19.1578947,17.3333333 C19.1578947,18.25 18.4,19 17.4736842,19 L5.68421053,19 C4.74947368,19 4,18.25 4,17.3333333 L4,5.66666667 C4,4.75 4.74947368,4 5.68421053,4 L17.4736842,4 C18.4,4 19.1578947,4.75 19.1578947,5.66666667 L19.1578947,6.5 L11.5789474,6.5 C10.6442105,6.5 9.89473684,7.25 9.89473684,8.16666667 L9.89473684,14.8333333 C9.89473684,15.75 10.6442105,16.5 11.5789474,16.5 L19.1578947,16.5 Z M11.5789474,14.8333333 L20,14.8333333 L20,8.16666667 L11.5789474,8.16666667 L11.5789474,14.8333333 Z M14.9473684,12.75 C14.2484211,12.75 13.6842105,12.1916667 13.6842105,11.5 C13.6842105,10.8083333 14.2484211,10.25 14.9473684,10.25 C15.6463158,10.25 16.2105263,10.8083333 16.2105263,11.5 C16.2105263,12.1916667 15.6463158,12.75 14.9473684,12.75 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.018f92f1c4ff195427e88de1a75a21c0.svg";
export { ForwardRef as ReactComponent };